$(document).ready(function () {
    stopPropagation();
    resolutionCheck();
    closeMDL();
    drop();
    closeDropdown();
    scrollToTop();
    scrollToElement();
    triggerClick();
    toggleTabsActiveClass();
    toggleDisplayByTab();
    objectFitImages();
    toggle();
    slideToggleFunction();

    formItemSplitHovered();
    formItemFocused();
    showOnCheck();
    showOnRadioCheck();
    formItemActiveDisable();
    refreshStyler();
    formItemInputNumCheck();
    formItemInputNumDotCheck();
    formItemInputNumCommaCheck();
    formItemInputNumDotMinusCheck();
    formItemEmailCheck();
    preventKeyboardTriggeringOnMobile();
    removeErrorFromFormItem();
    styler();
    multiselect();

    svg4everybody();

    closeDropdownGreen();
    dropGreen();

    /* JS for Hagerty only */
    closeHagerty();

    if ($('.datepicker').length) {
        $.datepicker._updateDatepicker_original =
            $.datepicker._updateDatepicker;
        $.datepicker._updateDatepicker = function (inst) {
            $.datepicker._updateDatepicker_original(inst);
            var afterShow = this._get(inst, 'afterShow');
            if (afterShow) {
                afterShow.apply(inst.input ? inst.input[0] : null);
            }
        };
        $('.datepicker').datepicker({
            /**
             * to prevent datepicker hide uncomment inline
             */
            changeMonth: true,
            changeYear: true,
            afterShow: function () {
                $('.ui-datepicker-title select').styler();
            },
            minDate: new Date(),
            dateFormat: 'dd/mm/y',
            defaultDate: +1,
            showOn: 'button',
            beforeShow: function () {
                $(this).addClass('visible');
            },
            onClose: function () {
                $(this).removeClass('visible');
            },
        });
        $(document).on('click touch', '.datepicker', function () {
            if ($(this).hasClass('visible')) {
                $(this).datepicker('hide');
            } else {
                $(this).datepicker('show');
            }
        });
    }
});

$(window).on('load', function () {
    documentHeight();
    const isSafari = getBrowser() === 'Safari';
    const body = document.querySelector('body');
    if (isSafari && body) {
        body.classList.add('safari');
    }
});

$(window).on('scroll', function () {
    var st = $(this).scrollTop();
    if (st > lastScrollTop) {
        // downscroll
    } else {
        // upscroll
    }
    lastScrollTop = st;
});

/*   $(window).on('resize orientationchange', function () {
    var res = resolutionCheck();
    fireTriggerClickOnMdlCloseBtn(res);
    documentHeight();
}); */
